import { MessagingHelper } from "../helpers/MessagingHelper";
import { ClientAddressCreateDTO } from "../models/ClientAddress/ClientAddressCreateDTO";
import { ClientAddressEditDTO } from "../models/ClientAddress/ClientAddressEditDTO";
import { ClientAddressDTO } from "../models/ClientAddress/ClientAdressDTO";
import { APIService } from "./APIService";

export class ClientAddressService {
  private axios = APIService.Axios();
  private baseUrl = `${APIService.GetURL()}/ClientAddress`;
  private headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: "Bearer " + APIService.GetToken(),
  };

  async getAllByClientId(clientId: number): Promise<MessagingHelper<ClientAddressDTO[]>> {
    try {
      const response = await this.axios.get<MessagingHelper<ClientAddressDTO[]>>(
        `${this.baseUrl}/GetByClientId/${clientId}`,
        { headers: this.headers }
      );
      return response.data;
    } catch {
      return new MessagingHelper<ClientAddressDTO[]>(
        false,
        "Erro ao obter os endereços do cliente",
        []
      );
    }
  }
  async  getAllActiveByClientId(clientId: number): Promise<MessagingHelper<ClientAddressDTO[]>> {
    try {
      const response = await this.axios.get<MessagingHelper<ClientAddressDTO[]>>(
        `${this.baseUrl}/GetAllActiveByClientId/${clientId}`,
        { headers: this.headers }
      );
      return response.data;
    } catch {
      return new MessagingHelper<ClientAddressDTO[]>(
        false,
        "Erro ao obter os endereços do cliente",
        []
      );
    }
  }
    

  async getById(id: number): Promise<MessagingHelper<ClientAddressDTO | null>> {
  try {
    const baseUrlFormatted = this.baseUrl.endsWith('/')
      ? this.baseUrl.slice(0, -1)
      : this.baseUrl;
    const url = `${baseUrlFormatted}/get/${id}`;
    const response = await this.axios.get<MessagingHelper<ClientAddressDTO | null>>(url, {
      headers: this.headers,
    });
    return response.data;
  } catch {
    return new MessagingHelper<ClientAddressDTO | null>(false, "Erro ao obter o endereço", null);
  }
}


  async create(dto: ClientAddressCreateDTO): Promise<MessagingHelper<ClientAddressDTO>> {
    try {
      const response = await this.axios.post<MessagingHelper<ClientAddressDTO>>(
        `${this.baseUrl}/Create`,
        dto,
        { headers: this.headers }
      );
      return response.data ?? new MessagingHelper(false, "Resposta vazia do servidor", {} as ClientAddressDTO);
    } catch {
      return new MessagingHelper<ClientAddressDTO>(
        false,
        "Erro ao criar o endereço",
        {} as ClientAddressDTO
      );
    }
  }

  async update(dto: ClientAddressEditDTO): Promise<MessagingHelper<ClientAddressDTO | null>> {
    try {
      const response = await this.axios.put<MessagingHelper<ClientAddressDTO | null>>(
        `${this.baseUrl}/Update`,
        dto,
        { headers: this.headers }
      );
      return response.data;
    } catch {
      return new MessagingHelper<ClientAddressDTO | null>(
        false,
        "Erro ao atualizar o endereço",
        null
      );
    }
  }

  async deactivate(id: number): Promise<MessagingHelper<boolean>> {
    try {
      const response = await this.axios.put<MessagingHelper<boolean>>(
        `${this.baseUrl}/Deactivate/${id}`,
        null,
        { headers: this.headers }
      );
      return response.data;
    } catch {
      return new MessagingHelper<boolean>(
        false,
        "Erro ao desativar o endereço",
        false
      );
    }
  }

  async activate(id: number): Promise<MessagingHelper<boolean>> {
    try {
      const response = await this.axios.put<MessagingHelper<boolean>>(
        `${this.baseUrl}/Activate/${id}`,
        null,
        { headers: this.headers }
      );
      return response.data;
    } catch {
      return new MessagingHelper<boolean>(
        false,
        "Erro ao ativar o endereço",
        false
      );
    }
  }
}
  